import PodcastPageConfig from "pages/podcast/config";
import { usePodcastProvider } from "components/podcast/PodcastProvider";
//ui
import { Flex, IconButton } from "@chakra-ui/react";
import { DiscordFilledIcon, TwitterFilledIcon, TelegramIcon, GithubIcon, ChevronFillIcon } from "components/icons";
import { PodcastIconButton } from "components/podcast/PodcastIconButton";

export function SubscribeModalContent() {
  const { onClose } = usePodcastProvider();
  return (
    <Flex flexDir="column" pt="12px" color="purple.50" width="100%" alignItems={{ base: "flex-start", md: "center" }} px={{ base: "8px", md: "0px" }}>
      <IconButton
        icon={<ChevronFillIcon width="48px" height="48px" />}
        width="24px"
        aria-label="close-modal"
        bg="transparent"
        borderRadius="24px"
        _hover={{ bg: "transparent" }}
        color="purple.50"
        onClick={onClose}
        display={{ base: "flex", md: "none" }}
      />
      <Flex width="100%" px={{ base: "31px", md: "0px" }} justifyContent="center" flexDir="column" pt={{ base: "16px", md: "0px" }}>
        {PodcastPageConfig.Subscribe}
        <Flex mt={{ base: "72px", md: "36px" }} maxWidth={{ base: "310px", md: "385px" }} mx="auto" width="100%" pb="62px" justifyContent="space-between">
          <PodcastIconButton name="twitterName" Icon={TwitterFilledIcon} color="purple.100" margin="15px" width="32px" height="32px" label="go-to-my-twitter-page" />
          <PodcastIconButton name="discordName" Icon={DiscordFilledIcon} color="purple.100" margin="15px" width="32px" height="32px" label="go-to-my-discord" />
          <PodcastIconButton name="telegramName" Icon={TelegramIcon} color="purple.100" margin="15px" width="32px" height="32px" label="go-to-my-telegram" />
          <PodcastIconButton name="githubName" Icon={GithubIcon} color="purple.100" margin="15px" width="32px" height="32px" label="go-to-my-github-page" />
        </Flex>
      </Flex>
    </Flex>
  );
}
